import { render, staticRenderFns } from "./BookingInputBasicView.vue?vue&type=template&id=7406b490&scoped=true&"
import script from "./BookingInputBasicView.vue?vue&type=script&lang=js&"
export * from "./BookingInputBasicView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7406b490",
  null
  
)

export default component.exports